import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './AnchorSecurityComponent.css';
import _ from 'lodash';
import { StorageApi } from '../../../utils/storageApi';
import { Button } from 'reactstrap';

class AnchorSecurityComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAnchorSecurityGotIt: StorageApi.getAnchorSecurityGotIt(),
        }
    }

    render() {
        return (
            <div className='anchor-security-container'>
                <h4 className='page-label'>
                    {_.get(this.props.translation, 'security.label')}
                </h4>
                <div className="info-container">
                    <span>{_.get(this.props.translation, 'security.anchor_info_part_1')}</span>
                    <br/>
                    <br/>
                    <span>{_.get(this.props.translation, 'security.anchor_info_part_2')}</span>
                    <br/>
                    <br/>
                    <span>{_.get(this.props.translation, 'security.anchor_info_part_3')}</span>
                </div>
                {
                    !this.state.isAnchorSecurityGotIt ?
                        <div className="buttons-group">
                            <Button
                                className='got-it-button olive-green-btn'
                                onClick={this.onGotItClick}
                            >
                                {_.get(this.props.translation, 'security.got_it_button')}
                            </Button>
                        </div>
                        : null
                }
            </div>
        );

    }

    onGotItClick = () => {
        StorageApi.setAnchorSecurityGotIt();
        this.setState({ isAnchorSecurityGotIt: true })
    }
}

AnchorSecurityComponent.propTypes = {
    translation: PropTypes.object,
};

export default AnchorSecurityComponent;



// WEBPACK FOOTER //
// ./src/components/securityManagement/anchorSecurityComponent/AnchorSecurityComponent.js